const yhpczl = [{
  path: 'yhpc_aqjcb',
  name: 'yhpc_aqjcb',
  component: () =>
            import('@/components/yhpczl/aqjcb'),
  meta: { title: '安全检查表', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_jcbz',
  name: 'yhpc_jcbz',
  component: () =>
            import('@/components/yhpczl/jcbz'),
  meta: { title: '检查标准', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhjd',
  name: 'yhpc_yhjd',
  component: () =>
            import('@/components/yhpczl/yhjd'),
  meta: { title: '风险隐患排查进度', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhpcjh',
  name: 'yhpc_yhpcjh',
  component: () =>
            import('@/components/yhpczl/yhpcjh'),
  meta: { title: '风险隐患排查任务', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'bbzrrlzqk',
  name: 'bbzrrlzqk',
  component: () =>
            import('@/components/yhpczl/bbzrelzqk'),
  meta: { title: '包保责任人隐患风险排查任务', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhpcrw',
  name: 'yhpc_yhpcrw',
  component: () =>
            import('@/components/yhpczl/yhpcrw'),
  meta: { title: '隐患排查任务', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhpcsh',
  name: 'yhpc_yhpcsh',
  component: () =>
            import('@/components/yhpczl/yhpcsh'),
  meta: { title: '隐患排查审核', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhsjjk',
  name: 'yhpc_yhsjjk',
  component: () =>
            import('@/components/yhpczl/yhsjjk'),
  meta: { title: '隐患数据监控', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhpc',
  name: 'yhpc_yhpc',
  component: () =>
            import('@/components/yhpczl/yhpc'),
  meta: { title: '隐患排查', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhqr',
  name: 'yhpc_yhqr',
  component: () =>
            import('@/components/yhpczl/yhqr'),
  meta: { title: '隐患确认', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhzl',
  name: 'yhpc_yhzl',
  component: () =>
            import('@/components/yhpczl/yhzl'),
  meta: { title: '隐患治理', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhyqsh',
  name: 'yhpc_yhyqsh',
  component: () =>
            import('@/components/yhpczl/yhyqsh'),
  meta: { title: '隐患延期审核', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhys',
  name: 'yhpc_yhys',
  component: () =>
            import('@/components/yhpczl/yhys'),
  meta: { title: '隐患验收', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhfh',
  name: 'yhpc_yhfh',
  component: () =>
            import('@/components/yhpczl/yhfh'),
  meta: { title: '隐患复核', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhxh',
  name: 'yhpc_yhxh',
  component: () =>
            import('@/components/yhpczl/yhxh'),
  meta: { title: '隐患销号', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'yhpc_yhtz',
  name: 'yhpc_yhtz',
  component: () =>
            import('@/components/yhpczl/yhtz'),
  meta: { title: '隐患台账', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhdb',
  name: 'yhdb',
  component: () =>
            import('@/components/yhpczl/thdb'),
  meta: { title: '隐患对比', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhtj',
  name: 'yhpc_yhtj',
  component: () =>
            import('@/components/yhpczl/yhtj'),
  meta: { title: '风险隐患统计', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhsc',
  name: 'yhpc_yhsc',
  component: () =>
            import('@/components/yhpczl/yhsc'),
  meta: { title: '隐患上传', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_ssp',
  name: 'yhpc_ssp',
  component: () =>
            import('@/components/yhpczl/ssp'),
  meta: { title: '隐患治理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_sspyhqr',
  name: 'yhpc_sspyhqr',
  component: () =>
            import('@/components/yhpczl/sspyhqr'),
  meta: { title: '隐患治理确认', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhzc',
  name: 'yhpc_yhzc',
  component: () =>
  import('@/components/yhpczl/yhzc'),
  meta: { title: '风险隐患排查结果', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhsjgl',
  name: 'yhsjgl',
  component: () =>
  import('@/components/yhpczl/yhsjgl'),
  meta: { title: '隐患数据管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhtzsc',
  name: 'yhpc_yhtzsc',
  component: () =>
            import('@/components/yhpczl/yhtzsc'),
  meta: { title: '隐患台账上传', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'bbzrr_lzqk',
  name: 'bbzrr_lzqk',
  component: () =>
  import('@/components/yhpczl/bbzrr'),
  meta: { title: '包保责任人履职情况', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'yhpc_yhsb',
  name: 'yhpc_yhsb',
  component: () =>
      import('@/components/yhpczl/yhsb'),
  meta: { title: '隐患上报', requireAuth: true, keepAlive: true, permission: true }
}
]
export default yhpczl



// WEBPACK FOOTER //
// ./src/router/yhpczl.js